import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { CookieManagementService as CookieService } from "Services/cookie-management.service";
import { FetchDataService } from "Services/fetch-data.service";
import { EventService } from "Services/event.service";
import { JwtHelper } from 'Classes/jwtHelper';
import { User } from "Classes/User";
//import { AdalService } from "ng2-adal/dist/core";
import { Adal4Service as AdalService } from 'adal-angular4';

import { ConfigService } from "Services/config.service";
import { AppConfig } from "Classes/AppConfig";
import { ModalConfig } from "Classes/ModalConfig";
declare var $: any;


@Injectable()
export class AuthenticationService {

    private _authenticationServiceUrl: string = this.fetchDataService.getUrl("authentication")
    private _authenticationUrl: string = this._authenticationServiceUrl + "token";
    private _passwordResetUrl: string = this._authenticationServiceUrl + "Authentication/ResetPassword";
    private _createPasswordUrl: string = this._authenticationServiceUrl + "Authentication/CreatePassword";
    private _checkPasswordResetUrl: string = this._authenticationServiceUrl + "Authentication/CheckPasswordReset";

    private _isAuthenticated: boolean;
    private _token: any;
    private _rawToken: string;

    private _rawAccessToken: string;
    private _rawCmToken: string;
    private _rawAmsToken: string;
    private _accessToken: any;
    private _cmToken: any;
    private _amsToken: any;

    private _smcAccess: boolean = false;
    private _cmAccess: boolean = false;
    //private _amsAccess: boolean = false;

    public _userId: string;
    public _userName: string;
    public _firstName: string = "";
    public _lastName: string = "";
    public _ramsUserName: string = "";
    private expireDate: Date;

    public _permissions: any = {
        addUser: "Add User"
    };

    constructor(
        private http: Http,
        private fetchDataService: FetchDataService,
        private eventService: EventService,
        private cookieService: CookieService,
        private adalService: AdalService,
        private configService: ConfigService,
        private appConfig: AppConfig
    )
    {
        this.init();
    }

    private init(): void
    {
        this._isAuthenticated = false;
        let config: any = this.configService.getAdalConfig;
        config.callback = this.broadcastLoginEvent.bind(this);
        this.adalInit(config);
    }

    broadcastLoginEvent(error, azureToken)
    {
        this.eventService.broadcast(this.eventService._loginWithSSO, azureToken);
    }

    private adalInit(configObject: any): void {

        this.adalService.init(configObject);
        //this.adalService.handleWindowCallback();

        //this.adalService.getUser();
    }

    public getTokenResponse(azureToken): Observable<any>
    {
        let url = process.env.AUTHENTICATION_URL + "AzureAuth?token="+azureToken;
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });

        let params = new URLSearchParams();

        let options = new RequestOptions({ headers: headers });
        return this.fetchDataService.get(url, options);
    }

    public registerCredentials(azureToken, smcToken): Observable<any>
    {
        let url = process.env.AUTHENTICATION_URL + "AzureAuth/RegisterSso?token="+azureToken;
        let headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + smcToken
        });

        let params = new URLSearchParams();

        let options = new RequestOptions({ headers: headers });
        return this.fetchDataService.get(url, options);
    }

    public authenticate(user: User): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });
        let body: any = this.getLoginBody(user);
        //if (twoFactorCode == null)
        //    body = JSON.stringify({ email: email, password: password });
        //else
        //    body = JSON.stringify({ email: email, password: password, twoFactorCode: twoFactorCode });
        return this.fetchDataService.post(this._authenticationUrl, body, options);
    }

    public resetPassword(email: string): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify({ Email: email });
        return this.fetchDataService.post(this._passwordResetUrl, body, options);
    }

    public createPassword(isRams: boolean, userid: string, token: string, password: string, confirmPassword: string) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });
        var body = JSON.stringify({ IsRams: isRams, UserId: userid, Token: token, Password: password, ConfirmPassword: confirmPassword });
        return this.fetchDataService.post(this._createPasswordUrl, body, options)
    }

    public checkPasswordReset(email: string, password: string) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });
        var body = JSON.stringify({ email: email, password: password });
        return this.fetchDataService.post(this._checkPasswordResetUrl, body, options);
    }

    public validateTokens(data): Observable<any> {
        let smc = Observable.of(false);
        let rams = Observable.of(false);
        let ams = Observable.of(false);
        if (data.AccessToken)
            smc = this.validateSmcToken(data.AccessToken);
        if (data.CmToken)
            rams = this.validateRamsToken(data.CmToken);
        if (data.AmsToken)
            ams = this.validateAmsToken(data.AmsToken);
        return Observable.zip(smc, rams, ams, (smcValid: boolean, ramsValid: boolean, amsValid: boolean): any => {
            return {
                AccessToken: smcValid,
                CmToken: ramsValid,
                AmsToken: amsValid
            };
        });
    }

    public validateSmcToken(token: string): Observable<any> {
        return Observable.of(true);
    }

    public validateRamsToken(token: string): Observable<any> {
        return Observable.of(true);
    }

    public validateAmsToken(token: string): Observable<any> {
        return Observable.of(true);
    }

    private getLoginBody(user: User): any {
        return JSON.stringify(user);
    }

    public setSSOCookie(sso: boolean)
    {
        this.cookieService.put("SSO", sso);
    }

    public setAuthData(authData: any): void {
        this.expireDate = new Date((new Date()).getTime() + this.fetchDataService.expireMinutes * 60 * 1000);
        let expireDate = this.expireDate;
        this._rawAccessToken = authData.AccessToken;
        this._rawCmToken = authData.CmToken;
        this._rawAmsToken = authData.AmsToken;
        if (this._rawAccessToken) {
            this.cookieService.put("RslAppPageToken", this._rawAccessToken, expireDate);
            this._accessToken = this.setTokenString(this._rawAccessToken);
            this._smcAccess = true;
        }
        if (this._rawCmToken) {
            this.cookieService.put("CmToken", this._rawCmToken, expireDate);
            this._cmToken = this.setTokenString(this._rawCmToken);
            this._cmAccess = true;
            this._ramsUserName = this._cmToken.nameid;
        }
        if (this._rawAmsToken) {
            //this.cookieService.put("AmsToken", this._rawAmsToken, { 'expires': expireDate, 'domain': ".doerer.us" });
            this._amsToken = this.setTokenString(this._rawAmsToken);
            //this._amsAccess = true;
        }
        this._userId = authData.UserId;
        this._firstName = authData.FName;
        this._lastName = authData.LName;
        this.cookieService.put("UserId", this._userId, expireDate);
        this.cookieService.put("FName", this._firstName, expireDate);
        this.cookieService.put("LName", this._lastName, expireDate);

        if (authData.AppTokens) {
            for (let token in authData.AppTokens)
                this.cookieService.put(token + "Token", authData.AppTokens[token], expireDate);
        }
        this.fetchDataService.setAuthData(this._accessToken, this._cmToken, this._amsToken, authData, expireDate);
    }

    public setUserData(email: any): void {
        this._userName = email;
    }

    public setTokenString(token: string) {
        let jwtHelper = new JwtHelper();
        let decodedToken = jwtHelper.decodeToken(token);
        return decodedToken;
    }

    public hasPermission(permission: string): boolean {
        let permissions = [];
        if (this._accessToken && this._accessToken.Permission) {
            
            if (typeof this._accessToken.Permission === "string")
                permissions.push(this._accessToken.Permission);
            else
                permissions.push.apply(permissions, this._accessToken.Permission);
        }
        if (this._cmToken && this._cmToken.Permission) {

            if (typeof this._cmToken.Permission === "string")
                permissions.push(this._cmToken.Permission);
            else
                permissions.push.apply(permissions, this._cmToken.Permission);
        }

        for (var perm of permissions)
            if (perm == permission)
                return true;
        return false;

    }

    public getRawToken(type: string): string {
        switch (type.toLowerCase()) {
            case "smc": return this._rawAccessToken;
            case "rams": return this._rawCmToken;
            case "ams": return this._rawAmsToken;
            default: console.error("Invalid token request!"); return "";
        }
    }

    public redirectToAzureAD(): void
    {
        this.adalService.login();
    }

    public async registerSSO()
    {
        let token = this._rawAccessToken;
        if (token)
        {
            try
            {
                let userInfo = await this.adalService.getUser().toPromise();
                let azureAccessToken;
                let tokenData;
                try
                {
                    azureAccessToken = await this.adalService.acquireToken(this.appConfig.azureResourceId).toPromise();

                } catch (e) { }
                if (azureAccessToken)
                {
                    //let message = `We will be logging you out now.`
                    //let config = new ModalConfig(
                    //    "confirm",
                    //    "Someone is already logged in to the Azure Active Directory!",
                    //    message,
                    //    $(document),
                    //    () => this.clearAndLogin(token),
                    //    () => this.register(token),
                    //    null,
                    //    "Yes",
                    //    "No"
                    //);
                    //this.eventService.broadcast(this.eventService._displayModal, config);
                    this.clearAndLogin(token);
                }
                else
                {
                    this.register(token);
                }
            }
            catch (e)
            {
                this.register(token);
            }
        }
    }

    public clearAndLogin(token)
    {
        this.cookieService.put("smc_token", token);
        this.eventService.broadcast(this.eventService._silentLogout, true);
    }

    public register(token)
    {
        this.cookieService.put("smc_token", token);
        this.redirectToAzureAD();
    }

    public async acquireAzureToken()
    {
        //this.adalService.acquireToken(this.appConfig.azureResourceId).subscribe(
        //    azureToken =>
        //    {
        //        console.log(azureToken);
        //    },
        //    err =>
        //    {
        //        console.error(err);
        //    }
        //)
        
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Services/authentication.service.ts